import React, { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { getDriverRides } from "../../Services/DriverService";
import Spinner from "react-bootstrap/Spinner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DriverRideTable = () => {
  const Columns = [
    {
      name: "Driver Name",
      selector: (row) => row.driver?.full_name,
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Source",
      selector: (row) => row.source?.address,
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Destination",
      selector: (row) => row.destination?.address,
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Date",
      selector: (row) => row["ride_date"],
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
      cell: (row) => <div>{formattedDate(row?.ride_date)}</div>,
    },
    {
      name: "Time",
      selector: (row) => row.ride_time,
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Amount",
      selector: (row) => `${row.amount} $`,
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Passanger Capacity",
      selector: (row) => row.passenger_capacity,
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
  ];

  const [driverRideList, setDriverRideList] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [pending, setPending] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);

  const getAllDriverRideList = async () => {
    try {
      const res = await getDriverRides();
      setDriverRideList(res.data);
      setFilteredUserList(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getAllDriverRideList();
  }, []);

  const formattedDate = (ride_date) => {
    const date = new Date(ride_date);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    if (!selectedDate) {
      setFilteredUserList(driverRideList);
    } else {
      const filtered = driverRideList.filter((ride) => {
        const created = new Date(ride.ride_date);
        return created.toDateString() === selectedDate.toDateString();
      });
      setFilteredUserList(filtered);
    }
  }, [selectedDate, driverRideList]);

  return (
    <Fragment>
      <div className="d-flex justify-content-end align-items-center mb-3">
        <label className="me-2">
          <strong>Filter by Date:</strong>
        </label>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          placeholderText="Select date"
          className="form-control"
          maxDate={new Date()}
          isClearable
        />
      </div>
      <div className="table-responsive support-table">
        {pending ? (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        ) : (
          <DataTable columns={Columns} data={filteredUserList} striped={true} center={true} pagination />
        )}
      </div>
    </Fragment>
  );
};

export default DriverRideTable;
